<template>
  <div class="attachments__wrapper">
    <template v-if="loading">
      <v-row no-gutters justify="center">
        <v-progress-circular color="primary" indeterminate size="25" />
      </v-row>
    </template>
    <template v-else>
      <CustomDataTable :items="items" :headers="headers" entity-type="attachments" :disable-pagination="true">
        <template v-slot:tools="{ item, index }">
          <v-icon v-if="hasDeleting" small @click="deleteRow(item, index)">mdi-delete</v-icon>
          <v-icon small @click="downloadAttachment(item)">mdi-download</v-icon>
        </template>
      </CustomDataTable>
    </template>
    <ConfirmDialog
      v-if="confirmDialogLoaded"
      :dialog="confirmDialogVisible"
      @success="confirmDelete()"
      @cancel="confirmDialogVisible = false"
    >
      <template v-slot:header>
        <h1>{{ $i18n.t(`dialog.header.deleteAttachment`) }}</h1>
      </template>
      <template v-slot:content>
        <p>{{ $i18n.t(`dialog.content.deleteAttachment`) }}</p>
      </template>
    </ConfirmDialog>
    <AddAttachment
      :attachmentEntitiesTypes="attachmentEntitiesTypes"
      :entity-id="entityId"
      :entity-type="entityType"
    />
  </div>
</template>

<script>
import CustomDataTable from '@/components/CustomDataTable';

export default {
  name: 'AttachmentsTable',
  props: {
    attachmentEntitiesTypes: {
      type: Array,
      default: () => {
        return [];
      }
    },
    entityType: {
      required: true,
      type: String
    },
    entityId: {
      required: true,
      type: [String, Number]
    },
    entities: {
      required: false,
      type: Array
    },
    hasDeleting: {
      type: Boolean,
      default: true
    },
    restriction: {
      type: String
    }
  },
  components: {
    CustomDataTable,
    ConfirmDialog: () => import('@/components/ConfirmDialog'),
    AddAttachment: () => import('@/components/AddAttachment')
  },
  data: () => ({
    confirmDialogLoaded: true,
    confirmDialogVisible: false,
    items: [],
    selectedItemIndex: undefined,
    headers: [
      {
        text: 'pl',
        value: 'pl',
        type: 'text'
      },
      {
        text: 'en',
        value: 'en',
        type: 'text'
      },
      {
        text: 'created_at',
        value: 'created_at',
        type: 'date'
      },
      {
        text: 'created_by',
        type: 'text',
        value: 'created_by'
      }
    ],
    loading: false
  }),
  methods: {
    addedItem(item) {
      const allowedEntities = [];
      allowedEntities.push({entityId: this.entityId, entityType: this.entityType});
      for (const type of this.attachmentEntitiesTypes) {
        if(type.value && type.items) {
          for (const item of type.items) {
            allowedEntities.push({entityId: item.value, entityType: type.value});
          }
        }
      }
      const entity = allowedEntities.find(entity => entity.entityId == item.entity_id && entity.entityType == item.entity_type);
      if (entity) {
        this.items.unshift(item);
      }
    },
    downloadAttachment(item) {
      let id = item.id;
      this.$store.dispatch('downloadAttachment', id).then(r => {
        if (r.status === 200) {
          const blob = new Blob([r.data], { type: r.data.type });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = r.headers['content-disposition'].match(
            /filename\*?=['"]?(?:UTF-\d['"]*)?([^;\r\n"']*)['"]?;?/
          )[1];
          link.click();
        } else {
          this.$root.$emit('showSnackbar', this.$i18n.t('offer.offers.errorDB'));
        }
      });
    },
    getAttachments() {
      this.loading = true;
      this.$store
        .dispatch('getAttachments', {
          type: this.entityType,
          id: this.entityId,
          params: {
            with_offers_attachments: this.entityType === 'project' || undefined,
            restrict: this.restriction || undefined
          }
        })
        .then(r => {
          if (r.status === 200) {
            const { files } = r.data;
            if (Array.isArray(files)) {
              this.items = files;
            } else {
              const { offer, parcels } = files;
              this.items = [...offer, ...[].concat(...parcels)];
              if (this.entityType === 'offer' && this.entities && this.entities.length) {
                this.headers.push({
                  text: 'nr_ew_dzialek',
                  value: 'nr_ew_dzialek',
                  type: 'text',
                  nullValueKey: 'default.notApplicable'
                });
                for (let idx in this.items) {
                  const item = this.items[idx];
                  this.items[idx].nr_ew_dzialek =
                    item.entity_type === 'parcel'
                      ? this.entities.find(ent => ent.id === item.entity_id).nr_ew_dzialek
                      : null;
                }
              }
            }
            this.isCommentAttachmentModal = true;
            this.isCommentAttachmentModal = false;
          }
          this.loading = false;
        });
    },
    deleteRow(item, index) {
      this.confirmDialogLoaded = true;
      this.confirmDialogVisible = true;
      this.deleteItem = item;
      this.deleteItemIndex = index;
    },
    confirmDelete() {
      this.$store.dispatch('deleteAttachment', this.deleteItem.id).then(() => {
        this.items.splice(this.deleteItemIndex, 1);
      });
      this.confirmDialogVisible = false;
    }
  },
  mounted() {
    this.getAttachments();
  },  
  created() {
    this.$root.$off('addedItem');
    this.$root.$on('addedItem', this.addedItem);
  },
  watch: {
    entityId() {
      this.getAttachments();
    }
  }
};
</script>

<style lang="scss">
.attachments__wrapper {
  height: 100%;
}
</style>
